import React, { useState } from "react";
import Crossicon from "../../../Icon/Crossicon";
import { Box, Modal, Typography, Button } from "@mui/material";
import { FontFamily } from "../../theme/fontFamily";
import { fontWeight } from "../../theme/fontWeight";
import { fontSize } from "../../theme/fontSize";
import { ThemeColor } from "../../theme/color";
import "../ConfirmationModal/Confirmation.css";
import DeleteMsg from "../DeleteMsgModal/DeleteMsg";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: "450px",
  bgcolor: "background.paper",
  boxShadow: "0px 8px 32px rgba(0, 0, 0, 0.16)",
  borderRadius: "20px",
  p: 4,
  outline: "none",
  border: "none",
  display: "flex",
  flexDirection: "column",
  gap: 3,
};

function ConfirmationModal(props) {
  const [confirmationopen, setConfirmationOpen] = useState(false);
  const [deleteMsgopen, setdeleteMsgOpen] = useState(false);

  const handleOpen = () => {
    props.handleConfirmationOpen();
  };

  const deletefunction = async () => {
    try {
      const val = await props.deletefunction(); // Await the result of the deletefunction
      if (val.status == 200) {
        handleClose();
        setdeleteMsgOpen(true);
      }
    } catch (error) {
      console.error("Error occurred:", error); // Handle any errors thrown by the async function
    }
  };

  const handleClose = () => {
    setConfirmationOpen(false);
    props.handleConfirmationClose();
  };
  return (
    <div>
      {/* modal for notes window */}
      <Modal
        open={props.confirmationopen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            fontFamily={FontFamily.Poppins}
            fontWeight={600}
            fontSize="1.35rem"
            color={ThemeColor.BLACK}
            align="center"
          >
            Are You Sure?
          </Typography>

          <Typography
            sx={{
              background: "rgba(19, 85, 155, 0.06)",
              color: "rgba(0, 0, 0, 0.75)",
              borderRadius: "12px",
              p: 2.5,
              border: "1px solid rgba(19, 85, 155, 0.12)",
              fontFamily: FontFamily.Poppins,
              fontSize: "0.95rem",
              fontWeight: 500,
              lineHeight: 1.6,
            }}
            align="center"
          >
            {props.message}
          </Typography>

          <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
            <Button
              variant="contained"
              fullWidth
              onClick={deletefunction}
              sx={{
                bgcolor: "rgba(19, 85, 155, 1)",
                color: "white",
                borderRadius: "12px",
                py: 1.25,
                textTransform: "none",
                fontWeight: 600,
                fontFamily: FontFamily.Poppins,
                fontSize: "0.95rem",
                boxShadow: "none",
                "&:hover": {
                  bgcolor: "rgba(19, 85, 155, 0.9)",
                  boxShadow: "none",
                },
              }}
            >
              {props.btnName ? props.btnName : "Delete"}
            </Button>
            <Button
              variant="contained"
              fullWidth
              onClick={handleClose}
              sx={{
                bgcolor: "rgba(236, 50, 57, 1)",
                color: "white",
                borderRadius: "12px",
                py: 1.25,
                textTransform: "none",
                fontWeight: 600,
                fontFamily: FontFamily.Poppins,
                fontSize: "0.95rem",
                boxShadow: "none",
                "&:hover": {
                  bgcolor: "rgba(236, 50, 57, 0.9)",
                  boxShadow: "none",
                },
              }}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
      <DeleteMsg
        msg={props?.msg}
        handledeleteMsgClose={() => {
          setdeleteMsgOpen(false);
        }}
        deleteMsgopen={deleteMsgopen}
        message="All deleted file is never been retrievable"
      />
    </div>
  );
}

export default ConfirmationModal;
